// The Magento pages include prototype.js, which adds its own custom version of `map` to the Array prototype.
// In this version of map, the argument is optional and defaults to an identity function.
//
// core-js also adds `map` to the Array prototype - but core-js' version requires an argument, per the spec.
// This is a problem because prototype.js code calls .map() with no argument, and it fails.
//
// So, we need to use yet another customer version of map that works with no arguments.

(function () {
    const _originalArrayMap = Array.prototype.map;
    const Identity = x => x;

    // eslint-disable-next-line no-extend-native
    Array.prototype.map = function () {
        // eslint-disable-next-line prefer-rest-params
        let args = arguments;
        if (!args.length) {
            args = [ Identity ];
        }
        if (!args[0]) {
            args[0] = Identity;
        }
        return _originalArrayMap.apply(this, args);
    };
}());
